import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { activitiesApi, UpdateActivityDto } from '../api/activitiesApi';
import { ActivitiesParams, CreateActivityDto } from '../types/activityTypes';
import { queryKeys, invalidateEntityQueries } from '@/shared/lib/react-query';

// Deprecated: используйте queryKeys.activities вместо этого
export const ACTIVITIES_QUERY_KEY = 'activities';
export const ACTIVITIES_PER_PAGE = 10;

export const useActivities = (page: number = 1, filters?: Partial<ActivitiesParams>) => {
  return useQuery({
    queryKey: queryKeys.activities.list(page, filters),
    queryFn: async () => {
      return activitiesApi.getActivities({
        offset: (page - 1) * ACTIVITIES_PER_PAGE,
        limit: ACTIVITIES_PER_PAGE,
        activity_type: filters?.activity_type,
        has_report: filters?.has_report,
        activity_start_date: filters?.activity_start_date,
        activity_end_date: filters?.activity_end_date,
      });
    },
  });
};

export const useCreateActivity = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: activitiesApi.createActivity,
    onSuccess: () => {
      invalidateEntityQueries.activities(queryClient);
    },
  });
};

export const useDeleteActivity = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: activitiesApi.deleteActivity,
    onSuccess: () => {
      invalidateEntityQueries.activities(queryClient);
    },
  });
};

export const useUpdateActivity = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: { id: string; data: UpdateActivityDto }) => {
      return activitiesApi.updateActivity(payload.id, payload.data);
    },
    onSuccess: (_, { id }) => {
      // Инвалидируем конкретную активность и весь список
      queryClient.invalidateQueries({ queryKey: queryKeys.activities.detail(id) });
      invalidateEntityQueries.activities(queryClient);
    },
  });
};
